const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const renderHighlightedText = (element, value, query) => {
    if (!element) {
        return;
    }

    const text = String(value || '');
    const terms = [...new Set(String(query || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean))]
        .sort((left, right) => right.length - left.length);

    element.textContent = '';

    if (!text || !terms.length) {
        element.appendChild(document.createTextNode(text));
        return;
    }

    const pattern = new RegExp(terms.map(escapeRegExp).join('|'), 'gi');
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    let match;

    // Keep result data as text nodes; only the locally-created mark element is HTML.
    while ((match = pattern.exec(text)) !== null) {
        if (match.index > cursor) {
            fragment.appendChild(document.createTextNode(text.slice(cursor, match.index)));
        }

        const mark = document.createElement('mark');
        mark.className = 'organisation-global-search__highlight';
        mark.textContent = match[0];
        fragment.appendChild(mark);
        cursor = match.index + match[0].length;
    }

    if (cursor < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(cursor)));
    }

    element.appendChild(fragment);
};

const organisationGlobalSearch = {
    init() {
        const $root = $('#global-search[data-organisation-global-search]');

        if (!$root.length) {
            return;
        }

        const state = {
            opened: false,
            request: null,
            debounce: null,
        };

        const $input = $root.find('[data-organisation-search-input]');
        const $results = $root.find('[data-organisation-search-results]');
        const searchUrl = $root.data('search-url');
        const resultsPageUrl = $root.data('results-page-url');
        const groupTemplate = document.getElementById('organisation-global-search-group-template');
        const resultTemplate = document.getElementById('organisation-global-search-result-template');
        const modalResultTemplate = document.getElementById('organisation-global-search-modal-result-template');
        const footerTemplate = document.getElementById('organisation-global-search-footer-template');

        const iconClasses = {
            page: 'fa-external-link',
            invoice: 'fa-file-text-o',
            job: 'fa-briefcase',
            order: 'fa-calendar-check-o',
            payment: 'fa-credit-card',
            'invoice-payment': 'fa-credit-card',
            estimate: 'fa-file-o',
            contact: 'fa-user-o',
            'customer-report': 'fa-bar-chart',
            'transaction-report': 'fa-line-chart',
            help: 'fa-question-circle-o',
        };

        const summaryUrl = (query) => {
            const url = new URL(resultsPageUrl, window.location.origin);
            if (query) {
                url.searchParams.set('query', query);
            }
            return `${url.pathname}${url.search}`;
        };

        const renderState = (message) => {
            $results.empty().append(
                $('<div>', {
                    class: 'organisation-global-search__state',
                    text: message,
                })
            );
        };

        const setOpened = (opened, shouldFocus = false) => {
            state.opened = opened;
            $root.toggleClass('is-open', opened);
            $input.attr('aria-expanded', opened ? 'true' : 'false');

            if (opened) {
                setTimeout(() => {
                    if (shouldFocus) {
                        $input.trigger('focus');
                    }
                    search($input.val());
                }, 50);
            }
        };

        const renderResult = (result, query) => {
            const template = result.modal_url ? modalResultTemplate : resultTemplate;
            const item = template.content.firstElementChild.cloneNode(true);
            const $item = $(item);

            if (result.modal_url) {
                $item.attr('data-organisation-search-modal-url', result.modal_url);
            } else {
                $item.attr('href', result.url || '#');
            }
            renderHighlightedText(
                $item.find('[data-organisation-search-result-title]').get(0),
                result.title || 'Untitled',
                query,
            );
            renderHighlightedText(
                $item.find('[data-organisation-search-result-description]').get(0),
                result.subtitle || result.description || '',
                query,
            );
            renderHighlightedText(
                $item.find('[data-organisation-search-result-category]').get(0),
                result.meta || result.category || '',
                query,
            );
            $item.find('[data-organisation-search-deposit-badge]')
                .prop('hidden', !result.is_deposit);
            $item.find('[data-organisation-search-result-icon]')
                .removeClass('fa-search')
                .addClass(iconClasses[result.type] || 'fa-search');

            return item;
        };

        const renderGroups = (response) => {
            const groups = response.groups || [];
            const query = response.query || '';

            if (!groups.length) {
                renderState('No results found');
                return;
            }

            if (!groupTemplate || !resultTemplate || !modalResultTemplate || !footerTemplate) {
                renderState('Search is temporarily unavailable');
                return;
            }

            $results.empty();

            groups.forEach((group) => {
                const groupNode = groupTemplate.content.firstElementChild.cloneNode(true);
                const $group = $(groupNode);
                const $items = $group.find('[data-organisation-search-group-items]');

                $group.find('[data-organisation-search-group-label]').text(group.label || 'Results');

                (group.results || []).forEach((result) => {
                    $items.append(renderResult(result, query));
                });

                const $showAll = $group.find('[data-organisation-search-show-all]');
                if (group.show_all_url && group.total > (group.results || []).length) {
                    $showAll.attr('href', group.show_all_url);
                } else {
                    $showAll.remove();
                }

                $results.append($group);
            });

            const footer = footerTemplate.content.firstElementChild.cloneNode(true);
            const $footer = $(footer);
            $footer.attr('href', response.all_results_url || summaryUrl(query));
            $footer.find('[data-organisation-search-query]').text(query ? `"${query}"` : 'all pages');
            $results.append($footer);
        };

        const fetchResults = (query) => {
            if (state.request) {
                state.request.abort();
            }

            $root.addClass('is-loading');
            renderState('Searching...');

            const request = $.ajax({
                method: 'GET',
                url: searchUrl,
                data: {
                    query: query || '',
                    limit: 4,
                },
                success: renderGroups,
                error: (response) => {
                    if (response.statusText !== 'abort') {
                        renderState('Search is temporarily unavailable');
                    }
                },
                complete: () => {
                    if (state.request === request) {
                        state.request = null;
                        $root.removeClass('is-loading');
                    }
                },
            });

            state.request = request;
        };

        const search = (query) => {
            clearTimeout(state.debounce);
            state.debounce = setTimeout(() => fetchResults(query), 225);
        };

        $input.on('focus', () => {
            if (!state.opened) {
                setOpened(true);
            }
        });

        $input.on('input', function () {
            if (!state.opened) {
                setOpened(true);
            }
            search($(this).val());
        });

        $input.on('keydown', (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                setOpened(false);
                $input.trigger('blur');
                return;
            }

            if (event.key === 'Enter') {
                event.preventDefault();
                window.location.href = summaryUrl($.trim($input.val()));
            }
        });

        document.addEventListener('keydown', (event) => {
            const isSearchShortcut = event.code === 'KeyK'
                || String(event.key || '').toLowerCase() === 'k';

            if ((event.ctrlKey || event.metaKey) && !event.altKey && isSearchShortcut) {
                event.preventDefault();
                setOpened(true);
                $input.get(0)?.focus({ preventScroll: true });
            }
        }, true);

        document.addEventListener('organisation-search:close', () => {
            clearTimeout(state.debounce);
            if (state.request) {
                state.request.abort();
                state.request = null;
            }
            $root.removeClass('is-loading');
            setOpened(false);
        });

        $(document).on('click', (event) => {
            if (!$(event.target).closest('[data-organisation-global-search]').length) {
                setOpened(false);
            }
        });
    },
};

export default organisationGlobalSearch;
